import { Component, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AlertService } from "src/app/providers/alert.service";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";

@Component({
  selector: "sm-new-add-new-employee",
  templateUrl: "./new-add-new-employee.component.html",
  styleUrls: ["./new-add-new-employee.component.scss"],
})
export class NewAddNewEmployeeComponent implements OnInit {
  countryInfo:any = typeof sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT) == 'string' ? JSON.parse(sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)!) : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)
  panelState: any = [true, false, false];
  public newEmployeeObj: any = {
    requestUserName: null,
    requestUserPhone: null,
    note: null,
    joiningDate: null,
    joiningSalary: null,
    salaryType: null,
  };
  apisub: Subscription;
  constructor(
    private navservice: NavigationService,
    private router: Router,
    private loaderService: LoaderServiceService,
    private _apiService: ApiService,
    private alertservice: AlertService,
    private route: ActivatedRoute
  ) {
    this.navservice.hideSidebarAndNav = false;

    this.apisub = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_SEND_EMPLOYEE_REQUEST
      ) {
        if (resData.result) {
          //  this.paymentResponse = null
          this.loaderService.showLoader = false;
          if(sessionStorage.getItem(SM_CONSTANTS.CURRENT_ROUTE_FOR_NEW_EMPLOYEE)== '1'){
            // this.alertservice.onOpenSnackbar("Employee request sent successfully", 10000, 'Ok')
            let obj = {
              employeeName: this.newEmployeeObj.requestUserName,
              businessname: localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_NAME),
              businesshash: localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_HASH)
            }
            sessionStorage.setItem('toShowAlert',JSON.stringify(obj))
            this.router.navigate(['/all-employees'])

          }else if(sessionStorage.getItem(SM_CONSTANTS.CURRENT_ROUTE_FOR_NEW_EMPLOYEE)== '2'){
            sessionStorage.setItem('toShowInvitation', '1')
            this.router.navigate(['../'],{relativeTo: this.route,queryParamsHandling: 'preserve'})
          }
          //  this.parentData.ref.closeAll();
        }
      }
    });
  }
  entityName: any
  entityAdd: any
  ngOnInit(): void {
    this.entityName = localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_NAME)
    this.entityAdd = localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_ADDRESS)
    this.selectedCountryCode = this.countryList.find(country => country.dial_code === this.countryInfo.countryCode && country.code === this.countryInfo.code)
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === "+91"
  );
  searchString: UntypedFormControl = new UntypedFormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }
  selectedPlan: any;
  onCreate() {
    this.selectedPlan =
      typeof sessionStorage.getItem(
        SM_CONSTANTS.SELECTED_EMPLOYEE_PURCHASED_PLAN
      ) == "string"
        ? JSON.parse(
            sessionStorage.getItem(
              SM_CONSTANTS.SELECTED_EMPLOYEE_PURCHASED_PLAN
            )!
          )
        : sessionStorage.getItem(SM_CONSTANTS.SELECTED_EMPLOYEE_PURCHASED_PLAN);
    let data = {
      requestInfo: {
        title: localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_NAME),
        note: this.newEmployeeObj.note
          ? this.newEmployeeObj.note
          : "No notes added",
        requestUserName: this.newEmployeeObj.requestUserName,
        requestUserPhone: this.newEmployeeObj.requestUserPhone,
        joiningDate: this.newEmployeeObj.joiningDate
          ? this.formatDate(
              new Date(this.newEmployeeObj.joiningDate).toLocaleDateString()
            )
          : null,
        subscriptionHash: this.selectedPlan.hash_id,
        joiningSalary:
          this.newEmployeeObj.joiningSalary +
          ".00, " +
          this.newEmployeeObj.salaryType,
        countryCode: this.selectedCountryCode.dial_code,
      },
    };
    console.log(data, localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_HASH));
    localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_HASH)
    this.loaderService.showLoader = true;
    this._apiService.sendEmployeeRequest(
      localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_HASH),
      data
    );
  }

  formatDate(originalDate: string): string {
    const parts = originalDate.split("/");
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  }
  goToBackWithParams(){
    const queryParams = { entityHash: this.route.snapshot.queryParams.entityHash };
    this.router.navigate(['../'], { queryParams, relativeTo: this.route });
    
  }

  formChecker() {
    if (this.newEmployeeObj.requestUserPhone) {
      if (this.newEmployeeObj.requestUserPhone.length >= 3 && this.newEmployeeObj.requestUserPhone.length <= 17) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}
